export const TESTIMONIALS = [
  {
    id: 't1',
    name: 'Maya Castillo',
    location: 'Miami, FL',
    quote:
      'Premium’s AI home analysis flagged roof and HVAC risks we would have missed. We negotiated with confidence before closing.',
    rating: 5,
  },
  {
    id: 't2',
    name: 'James Whitfield',
    location: 'Delray Beach, FL',
    quote:
      'The full property reports saved us weeks of digging. Clear history, disclosures, and condition intel in one place.',
    rating: 5,
  },
  {
    id: 't3',
    name: 'Priya Mehta',
    location: 'Boca Raton, FL',
    quote:
      'Neighborhood and market profitability views showed which Boca pockets still had room to grow. That shaped our offer strategy.',
    rating: 5,
  },
  {
    id: 't4',
    name: 'Daniel Ortiz',
    location: 'Fort Lauderdale, FL',
    quote:
      'Renovation cost estimates kept our remodel budget honest. We knew room-by-room numbers before we bid.',
    rating: 5,
  },
  {
    id: 't5',
    name: 'Lauren Brooks',
    location: 'Jupiter, FL',
    quote:
      'Verified contractor quotes turned our estimates into real bids from vetted pros. No more guessing on kitchen costs.',
    rating: 5,
  },
  {
    id: 't6',
    name: 'Marcus Hale',
    location: 'West Palm Beach, FL',
    quote:
      'Profit and ROI analysis made the upside after purchase and improvements crystal clear. We bought the home that penciled out.',
    rating: 5,
  },
  {
    id: 't7',
    name: 'Sofia Alvarez',
    location: 'Tampa, FL',
    quote:
      'Virtual interior redesign helped us picture finishes before we committed. The Tampa condo finally felt like ours.',
    rating: 5,
  },
  {
    id: 't8',
    name: 'Ethan Clarke',
    location: 'Orlando, FL',
    quote:
      'Premium paid for itself on our first Orlando purchase. AI analysis plus the full report cut through listing spin.',
    rating: 5,
  },
  {
    id: 't9',
    name: 'Nadia Rahman',
    location: 'Naples, FL',
    quote:
      'Market profitability data for Naples neighborhoods helped us avoid overpaying in a hot stretch of inventory.',
    rating: 5,
  },
  {
    id: 't10',
    name: 'Chris Donovan',
    location: 'Sarasota, FL',
    quote:
      'We used renovation estimates and ROI side by side. Casahom Premium turned a gut-feeling remodel into a plan.',
    rating: 5,
  },
  {
    id: 't11',
    name: 'Aisha Bennett',
    location: 'St. Petersburg, FL',
    quote:
      'The AI walkthrough of condition risks gave us talking points with the inspector. Calm, specific, and useful.',
    rating: 4,
  },
  {
    id: 't12',
    name: 'Ryan Patel',
    location: 'Coral Gables, FL',
    quote:
      'Full reports on every listing we toured meant fewer surprises. Premium felt like homework we didn’t have to do alone.',
    rating: 5,
  },
  {
    id: 't13',
    name: 'Emily Torres',
    location: 'Palm Beach Gardens, FL',
    quote:
      'Contractor quotes through Premium were fast and credible. We remodeled a guest suite without blowing the budget.',
    rating: 5,
  },
  {
    id: 't14',
    name: 'Kevin Morgan',
    location: 'Clearwater, FL',
    quote:
      'ROI analysis showed average upside after light improvements. That convinced us to buy and renovate instead of waiting.',
    rating: 5,
  },
  {
    id: 't15',
    name: 'Hannah Greer',
    location: 'Fort Myers, FL',
    quote:
      'Virtual redesign previews sold my partner on the bones of a dated Fort Myers ranch. We saw the potential, then bought.',
    rating: 5,
  },
  {
    id: 't16',
    name: 'Omar Siddiqui',
    location: 'Hollywood, FL',
    quote:
      'Neighborhood comps and demand signals helped us price our Hollywood sale. We listed once and got serious offers.',
    rating: 5,
  },
  {
    id: 't17',
    name: 'Claire Nguyen',
    location: 'Winter Park, FL',
    quote:
      'Premium’s renovation estimates matched what local pros later quoted. Trustworthy numbers made bidding less stressful.',
    rating: 4,
  },
  {
    id: 't18',
    name: 'Brian Soto',
    location: 'Miami Beach, FL',
    quote:
      'From AI analysis to profit projections, Premium felt built for Florida buyers who want clarity before they write a check.',
    rating: 5,
  },
];
